<template>
    <div class="loader-container">
        <div class="check"></div>
    </div>
</template>

<script>

export default {
  name: 'CheckedMark',
  data () {
    return {}
  }
}
</script>

<style scoped lang='less'>
</style>
